// export const BASE_URL = 'http://beeserver:85/api'
// export const BASE_URL = 'https://beetasking-mirror-api.beetronix.com/api'
// export const BASE_URL = 'http://beeserver:85/api'
// export const BASE_URL = 'http://localhost:8005/api'
// export const BASE_URL = 'https://localhost:7297/api'
// export const BASE_URL = 'https://beetasking-api.beetronix.com/api'
// export const BASE_URL = 'https://localhost:7297/api'
export const BASE_URL = 'https://task-api.rowadalmustakbal.edunixsystem.com/api'
